import { FeedbackSubmissionRequest } from '@admin/template-elements/edit-list/types'
import { GET, POST } from '../endpoints'
import { fetchData, postData } from '../utils'

interface LiveblocksAuthResponse {
  token: string
}

export const getLiveblocksAuth = async () =>
  fetchData<LiveblocksAuthResponse>({
    endpoint: GET.liveblocksAuth(),
  })

type UsersResponse = {
  uuid: string
  name: string
  email: string
}[]
export const getUsers = async (userUuids: string[]) => {
  // Create URLSearchParams with multiple uuids parameters
  const searchParams = new URLSearchParams()
  userUuids.forEach(uuid => {
    searchParams.append('uuids', uuid)
  })

  return fetchData<UsersResponse>({
    endpoint: GET.getUsers(),
    params: searchParams,
  })
}

export const submitLiveblocksFeedback = async request =>
  postData<never, FeedbackSubmissionRequest>({
    endpoint: POST.liveblocksFeedback(),
    queryOptions: request,
  })

type LiveblocksPendingSuggestionsResponse = {
  listId: number
  pendingComments: number
  pendingSuggestions: number
  lockData: {
    lockedBy: string
    lockedAt: number
    isLocked: boolean
  } | null
}[]
export const getLiveblocksPendingSuggestions = async () =>
  fetchData<LiveblocksPendingSuggestionsResponse>({
    endpoint: GET.liveblocksPendingSuggestions(),
  })
